import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";


/**
 * ATENA CONSULTING — sidebar-contatti.js
 *
 * Apertura da:
 *  - class="open-sidebar-contatti" sul <li> menu WordPress
 *  - data-open-sidebar="contatti" su qualsiasi elemento
 *
 * Posizione sidebar (destra/sinistra):
 *  - letta da data-sidebar-position sul trigger
 *  - default: destra
 */

const sidebarContatti = () => {

  console.log('sidebarContatti init');

  let isOpen = false;

  // ── Helper: recupera elementi ──────────────────────────
  // Cercati al momento dell'uso — non all'init
  function getSidebar() { return document.getElementById('sidebar-contatti'); }
  function getOverlay()  { return document.getElementById('sidebar-overlay');  }

  // ── Imposta posizione ──────────────────────────────────
  function setPosition(sidebar, position) {
    if (position === 'sinistra') {
      sidebar.classList.add('is-left');
    } else {
      sidebar.classList.remove('is-left');
    }
  }

  // ── Apertura ───────────────────────────────────────────
  function open(position) {
    const sidebar = getSidebar();
    const overlay = getOverlay();
    if (!sidebar || isOpen) return;

    isOpen = true;
    setPosition(sidebar, position || 'destra');

    sidebar.classList.add('is-open');
    sidebar.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';

    // Focus sul primo elemento interattivo
    const focusable = sidebar.querySelector('button, input, select, textarea, a[href]');
    if (focusable) setTimeout(() => focusable.focus(), 500);
  }

  // ── Chiusura ───────────────────────────────────────────
  function close() {
    const sidebar = getSidebar();
    const overlay = getOverlay();
    if (!sidebar || !isOpen) return;

    isOpen = false;

    sidebar.classList.remove('is-open');
    sidebar.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }

  // ── Delegazione eventi — apertura ─────────────────────
  // Event delegation su document — funziona anche se la
  // sidebar non è ancora nel DOM al momento dell'init
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest(
      '.open-sidebar-contatti a, [data-open-sidebar="contatti"]'
    );
    if (!trigger) return;

    e.preventDefault();

    const position =
      trigger.dataset.sidebarPosition ||
      trigger.closest('[data-sidebar-position]')?.dataset.sidebarPosition ||
      'destra';

    open(position);
  });

  // ── Delegazione eventi — chiusura ─────────────────────
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-close-sidebar="contatti"]');
    if (trigger) close();
  });

  // ── ESC ────────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  // ── Animazione blocco CTA ──────────────────────────────
  function initCtaBlocks() {
    document.querySelectorAll('[data-animate-block]').forEach(block => {

      const inner = block.querySelector('.blocco_cta_form__inner');
      const cta   = block.querySelector('.blocco_cta_form__cta-wrap');

      if (!inner) return;

      gsap.set(inner, { opacity: 0, y: 20 });
      if (cta) gsap.set(cta, { opacity: 0, y: 8 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: block,
          start:   'top 85%',
          once:    true,
        },
      });

      // 1. Sfondo — fade + lieve slide
      tl.to(inner, {
        opacity:  1,
        y:        0,
        duration: 0.7,
        ease:     'power3.out',
      });

      // 2. Titolo — gestito da animations.js (data-animate="clip-up")

      // 3. CTA — fade dopo il titolo
      if (cta) {
        tl.to(cta, {
          opacity:  1,
          y:        0,
          duration: 0.45,
          ease:     'power3.out',
        }, '<0.4');
      }

    });
  }

  // ── Init animazioni ────────────────────────────────────
  if (document.readyState === 'complete') {
    initCtaBlocks();
  } else {
    window.addEventListener('load', initCtaBlocks);
  }

};

export default sidebarContatti;